import React, { useState } from "react";
import { OTelSpan } from "../types";
import { Search } from "lucide-react";

interface GenericSpanViewProps {
  span: OTelSpan;
}

export const GenericSpanView: React.FC<GenericSpanViewProps> = ({ span }) => {
  const [search, setSearch] = useState("");

  const attributes = Object.entries(span.attributes).filter(([key]) =>
    key.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Search Bar */}
      <div className="px-5 py-3 border-b border-[#e2e8f0] bg-white">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#94a3b8]" />
          <input
            type="text"
            data-testid="span-attributes-search"
            placeholder="Filter attributes..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-[#f8fafc] border border-[#e2e8f0] rounded-md pl-9 pr-3 py-1.5 text-sm text-[#0f172a] placeholder-[#94a3b8] focus:outline-none focus:border-[#94a3b8] transition-colors"
          />
        </div>
      </div>

      {/* Attributes Table */}
      <div className="flex-1 overflow-y-auto">
        <table className="w-full text-left border-collapse">
          <thead className="sticky top-0 bg-white border-b border-[#e2e8f0] z-10">
            <tr>
              <th className="px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-[#64748b] w-1/3 min-w-[200px]">
                Key
              </th>
              <th className="px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-[#64748b]">
                Value
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#e2e8f0]">
            {attributes.length > 0 ? (
              attributes.map(([key, value]) => (
                <tr
                  key={key}
                  data-testid="span-attribute-row"
                  data-attribute-key={key}
                  className="hover:bg-[#f8fafc] transition-colors group"
                >
                  <td className="px-5 py-3 text-sm text-[#0f172a] font-mono break-words align-top min-w-[200px]">
                    {key}
                  </td>
                  <td className="px-5 py-3 text-sm text-[#64748b] font-mono break-words align-top">
                    {typeof value === "object" ? (
                      <pre className="whitespace-pre-wrap">
                        {JSON.stringify(value, null, 2)}
                      </pre>
                    ) : (
                      String(value)
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={2}
                  data-testid="span-attributes-empty"
                  className="px-5 py-8 text-center text-sm text-[#94a3b8]"
                >
                  No attributes found matching "{search}"
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
